// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormLinkContract } from '../../forms/FormLinkContract/FormLinkContract';

// types
import { V2Contract } from '../../../@types';

// Props

export interface DialogLinkContractProps {
	contract?: V2Contract | null;
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
	preSelectedActivityId?: number;
	preSelectedContractId?: number;
}

// Component

export const DialogLinkContract = ({
	contract,
	isOpen,
	onClose,
	onSuccess,
	preSelectedActivityId,
	preSelectedContractId,
}: DialogLinkContractProps) => {
	// hooks
	const { t } = useTranslation();

	// derived
	const isEditMode = Boolean(contract);

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: isEditMode ? 'Update Contract' : 'Link Contract',
					form: isEditMode ? 'form-edit-contract' : 'form-link-contract',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={600}
			onClose={onClose}
			title={{
				children: isEditMode ? 'Edit Contract' : 'Link Contract to Activity',
				variant: 'h3',
			}}>
			<FormLinkContract
				contract={contract}
				onClose={onClose}
				onSuccess={onSuccess}
				preSelectedActivityId={preSelectedActivityId}
				preSelectedContractId={preSelectedContractId}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
